import React, { useEffect, useState } from "react";

export default function ThousandPlusCounter() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (count >= 1000) return;

    const interval = setInterval(() => {
      setCount((prev) => {
        if (prev >= 1000) {
          clearInterval(interval);
          return 1000;
        }
        return prev + 10; // brzina brojanja
      });
    }, 50); // brzina animacije

    return () => clearInterval(interval);
  }, []);

  return (
    <h2 style={{ fontSize: "40px", fontWeight: "bold" }}>
      {count >= 1000 ? "1000+" : count}
    </h2>
  );
}